
import { client } from '@/common-utils/libraries/axios/axios';
import SIM_CARD from '../apiUrls';

const mutationAddSimCards = (onSuccess, onError) => {
    return {
        mutationFn: ({ simProvider, iccids, organizationId }) => {
            return client.post(SIM_CARD.COLLECTION.url, { simProvider, iccids, client: organizationId });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddSimCards;